import { ExclamationCircleIcon, InfoIcon as InfoIcon$1, CircleCheckIcon, ExclamationTriangleIcon, ProgressCircleIcon, CaretDownIcon } from '@panwds/icons';
import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import { useIntl } from 'react-intl';

const DangerIcon = ({ ...iconProps }) => {
    const intl = useIntl();
    return (React.createElement(ExclamationCircleIcon, { className: "tw-text-red-500", ...iconProps, ariaLabel: intl.formatMessage({
            defaultMessage: 'Danger',
            id: 'rVKYSV',
            description: 'Danger Icon label'
        }) }));
};
DangerIcon.displayName = 'DangerIcon';
const InfoIcon = ({ ...iconProps }) => {
    const intl = useIntl();
    return (React.createElement(InfoIcon$1, { className: "tw-text-link dark:tw-text-blue-400", ...iconProps, ariaLabel: intl.formatMessage({
            defaultMessage: 'More info',
            id: 'PVaBXM',
            description: 'More info Icon label'
        }) }));
};
InfoIcon.displayName = 'InfoIcon';
const SuccessIcon = ({ ...iconProps }) => {
    const intl = useIntl();
    return (React.createElement(CircleCheckIcon, { className: "tw-text-teal-600 dark:tw-text-teal-400", ...iconProps, ariaLabel: intl.formatMessage({
            defaultMessage: 'Success',
            id: 'a6vCkm',
            description: 'Success Icon label'
        }) }));
};
SuccessIcon.displayName = 'SuccessIcon';
const WarningIcon = ({ ...iconProps }) => {
    const intl = useIntl();
    return (React.createElement(ExclamationTriangleIcon, { className: "tw-text-orange-400 dark:tw-text-yellow-300", ...iconProps, ariaLabel: intl.formatMessage({
            defaultMessage: 'Warning',
            id: '2NNMLm',
            description: 'Warning Icon label'
        }) }));
};
WarningIcon.displayName = 'WarningIcon';
const LoadingIcon = ({ ...iconProps }) => {
    const intl = useIntl();
    return (React.createElement(ProgressCircleIcon, { className: "tw-animate-spin", ...iconProps, ariaLabel: intl.formatMessage({
            defaultMessage: 'Loading',
            id: 'rVslWc',
            description: 'Loading Icon label'
        }) }));
};
const defaultProps = {
    appearance: 'secondary'
};
function ProgressRing(props) {
    const { radius, stroke, progress, apperance, appearance } = props;
    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (progress / 100) * circumference;
    const intl = useIntl();
    const ringStrokeColor = (appearance !== null && appearance !== void 0 ? appearance : apperance) === 'secondary' ? '#38A5FF' : '#016FCC';
    return (React.createElement("svg", { height: radius * 1.99, width: radius * 1.99 },
        React.createElement("title", null, intl.formatMessage({
            defaultMessage: 'Progress',
            id: '0h33kH',
            description: 'Progress indicator label'
        })),
        React.createElement("circle", { stroke: ringStrokeColor, fill: "transparent", strokeWidth: stroke, strokeDasharray: `${circumference} ${circumference}`, style: {
                transform: 'rotate(-90deg)',
                transformOrigin: '50% 50%',
                transition: 'strokeDashoffset 0.35s'
            }, r: normalizedRadius, cx: radius, cy: radius }),
        React.createElement("circle", { stroke: "currentColor", fill: "transparent", strokeWidth: stroke, strokeDasharray: `${circumference} ${circumference}`, style: {
                transform: 'rotate(-90deg)',
                transformOrigin: '50% 50%',
                transition: 'strokeDashoffset 0.35s',
                strokeDashoffset,
                zIndex: 10
            }, r: normalizedRadius, cx: radius, cy: radius })));
}
ProgressRing.displayName = 'ProgressRing';
ProgressRing.defaultProps = defaultProps;
const defaultPropsMenuIcon = {
    isOpen: false,
    buttonType: 'default'
};
const MenuIcon = ({ isOpen, customWidth, buttonType, ...iconProps }) => {
    const intl = useIntl();
    return (React.createElement("span", { "data-testid": "menuicon-container", ...(customWidth && { style: { width: customWidth } }), className: classNames('tw-ml-1 tw-w-5 tw-h-5 tw-grid tw-items-center tw-justify-items-end', (buttonType === 'form-select' || customWidth) && 'tw-absolute tw-right-1.5') },
        React.createElement(CaretDownIcon, { ariaLabel: intl.formatMessage({
                defaultMessage: 'Menu Icon',
                id: 'F3cWLG',
                description: 'Menu Icon Label'
            }), size: "xs", ...iconProps, className: `tw-transform tw-transition-transform tw-duration-200 ${isOpen && 'tw-rotate-180'}` })));
};
MenuIcon.defaultProps = defaultPropsMenuIcon;
MenuIcon.displayName = 'MenuIcon';

export { DangerIcon, InfoIcon, LoadingIcon, MenuIcon, ProgressRing, SuccessIcon, WarningIcon };
//# sourceMappingURL=SemanticIcons.esm.js.map
